import config from"../../app.config/bootstrap";import{$config}from"../../app.config/schema";export default $config.parse(config);